export default __webpack_public_path__ + "static/media/Check_Icon.b40df6e7.svg";